import type { FragmentOf } from "@opensea/graphql"
import { readFragment } from "@opensea/graphql"
import type { AddressDisplay } from "@opensea/ui-kit"
import { isAddressEqual } from "@opensea/utils"
import { useTranslations } from "next-intl"
import { useActivityEnumName } from "@/hooks/use-enum-name"
import { useProfileAddress } from "../profile/ProfileAddressProvider"
import { ActivityEventFragment } from "./ActivityEvent.fragment"

type Props = {
  activity: FragmentOf<typeof ActivityEventFragment>
  display?: AddressDisplay
}

export function ActivityEvent({ activity: activityKey }: Props) {
  const activity = readFragment(ActivityEventFragment, activityKey)
  const address = useProfileAddress()
  const t = useTranslations("ActivityEvent")
  const activityEnumName = useActivityEnumName()

  if (activity.type === "LISTING" && activity.to) {
    return <>{activityEnumName("PRIVATE_LISTING")}</>
  }

  switch (activity.type) {
    case "TRANSFER":
      if (isAddressEqual(address, activity.from.address)) {
        return <>{t("send")}</>
      }
      if (isAddressEqual(address, activity.to?.address)) {
        return <>{t("receive")}</>
      }
      return <>{activityEnumName(activity.type)}</>
    default:
      return <>{activityEnumName(activity.type)}</>
  }
}
